// test1967
(1967 && 0);
